export default __webpack_public_path__ + "static/media/call-split.d72db253.svg";